module.exports = "/virtual-football-league/img/amblems/right/logos/Fake_SwanCity.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Fake_SwanCity.png
// module id = 2195
// module chunks = 4